module.exports = __webpack_public_path__ + "img/candela-apps-dark-01.aa39f5d2.png";